import React, { useEffect } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';

import { apiTrack } from 'lib/analytics';
import { SERVICES_REQUEST_PATH } from 'routes';
import { actions } from 'store/ServicesRequest';
import { selectLaunchPath, selectServicesRequestServices } from 'store/ServicesRequest/selectors';
import { useAppDispatch, useAppSelector } from 'store/hooks';

import ExitModal from './ExitModal';
import ServicesRequestConfirmation from './ServicesRequestConfirmation';
import ServicesRequestCongrats from './ServicesRequestCongrats';
import ServicesRequestContact from './ServicesRequestContact';
import ServicesRequestLocation from './ServicesRequestLocation';
import ServicesRequestMove from './ServicesRequestMove';
import ServicesRequestServices from './ServicesRequestServices';
import ServicesRequestSetUp from './ServicesRequestSetUp';
import ServicesRequestSize from './ServicesRequestSize';
import ServicesRequestWelcome from './ServicesRequestWelcome';
import { generateServicesRequestStepPath } from './utils';

interface Props {}

const ServicesRequest: React.FC<Props> = () => {
  const services = useAppSelector(selectServicesRequestServices);
  const { pathname, state } = useLocation<{ prevPath?: string }>();
  const _launchPath = useAppSelector(selectLaunchPath);
  const launchPath = state?.prevPath || _launchPath;
  const dispatch = useAppDispatch();

  useEffect(() => {
    apiTrack('Services Request Started', {
      launchPath: launchPath || null
    });

    if (!!launchPath) {
      dispatch(actions.setLaunchPath(launchPath));
    }

    return () => {
      dispatch(actions.setExitModalIsVisible(false));
      dispatch(actions.reset());
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (
    !services.length &&
    ![`${SERVICES_REQUEST_PATH}/welcome`, `${SERVICES_REQUEST_PATH}/services`].includes(pathname)
  ) {
    return <Redirect to={generateServicesRequestStepPath({ step: 'welcome' })} />;
  }

  return (
    <>
      <ExitModal />
      <Switch>
        <Route path={generateServicesRequestStepPath({ step: 'welcome' })} exact>
          <ServicesRequestWelcome />
        </Route>
        <Route path={generateServicesRequestStepPath({ step: 'services' })} exact>
          <ServicesRequestServices />
        </Route>
        <Route path={generateServicesRequestStepPath({ step: 'location' })} exact>
          <ServicesRequestLocation />
        </Route>
        <Route path={generateServicesRequestStepPath({ step: 'size' })} exact>
          <ServicesRequestSize />
        </Route>
        <Route path={generateServicesRequestStepPath({ step: 'move' })} exact>
          <ServicesRequestMove />
        </Route>
        <Route path={generateServicesRequestStepPath({ step: 'congrats' })} exact>
          <ServicesRequestCongrats />
        </Route>
        <Route path={generateServicesRequestStepPath({ step: 'set-up' })} exact>
          <ServicesRequestSetUp />
        </Route>
        <Route path={generateServicesRequestStepPath({ step: 'contact' })} exact>
          <ServicesRequestContact />
        </Route>
        <Route path={generateServicesRequestStepPath({ step: 'confirmation' })} exact>
          <ServicesRequestConfirmation />
        </Route>
        <Redirect to={generateServicesRequestStepPath({ step: 'welcome' })} />
      </Switch>
    </>
  );
};

export default ServicesRequest;
